<template>
  <div class="common-send-code">
    <!-- <flex-line :show-border="true">
      <span>Verification Method</span>
      <div slot="right">
        <mt-radio v-model="verifyType" :options="verifyTypeOptions">
        </mt-radio>
      </div>
    </flex-line> -->
    <div class="field-name">Verification Code</div>
    <flex-line class="field-line menu-item input-wrapper" :show-border="true">
      <span class="field-name"></span>
      <div class="field-line-right" style="background-color: #fafafa;display: flex;align-items: center;">
        <input style="padding-right:10px;width: 100%;height: 40px;background-color: #fafafa;" class="field-input" v-model="verifyCode"/>
        <div @click="sendAuthCode" class="common-btn send-btn">{{ sendStateText }}</div>
      </div>
    </flex-line>
    <!-- <div class="common-btn ds-button-large mt-10" @click='checkAuthCode' v-if="showAuthCode">Next Step</div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { sendAuthCode, checkAuthCode } from '../../../api/memberSetting'
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  name: 'CommonSendCode',
  components: {
    flexLine,
  },
  data() {
    return {
      verifyType: 'email',
      verifyCode: '',
      canSend: true,
      sendStateText: 'send',
      verifyTypeOptions: [],
      showAuthCode: true,
    }
  },
  beforeDestroy: function () {
    clearInterval(this.time_interval)
  },
  created: function () {
    if (this.user.member_mobilebind && this.user.member_mobile) {
      this.verifyTypeOptions.push({
        label: 'mobile',
        value: 'mobile'
      })
      this.verifyType = 'mobile'
    }
    if (this.user.member_emailbind && this.user.member_email) {
      this.verifyTypeOptions.push({
        label: 'email',
        value: 'email'
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  methods: {
    sendAuthCode() {
      if (!this.canSend) {
        return
      }
      sendAuthCode(this.verifyType).then(res => {
        this.canSend = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.time_interval = setInterval(function () {
          if (second <= 0) {
            _this.canSend = true
            _this.sendStateText = 'send'
            clearInterval(_this.time_interval)
          } else {
            _this.sendStateText = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    checkAuthCode() {
      checkAuthCode(this.verifyCode).then(res => {
        if (res.message) {
          Toast(res.message)
        }
        if (res.code == 10000) {
          this.$emit('checkSuccess')
          this.showAuthCode = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style  lang="scss" scoped>
.common-send-code {
  position: relative;
  z-index: 100;
  .send-btn {
    border: 1px solid $primaryColor;
    color: $primaryColor;
    min-width: 2rem;
    margin-top: 10px;
  }
}
</style>
<style  lang="scss">
.field-name {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  margin: 0.5rem 0;
}
.common-send-code {
  position: relative;
  z-index: 100;
  .mint-radiolist {
    display: flex;
    .mint-cell {
      flex: 1;
      .mint-radio-input:checked+.mint-radio-core {
        background-color: $primaryColor !important;
        border-color: $primaryColor !important;
      }

      &:after {
        display: none
      }
    }
  }
}
</style>
